import React from 'react';
import { useConfig } from '../../ConfigContext';
import { fontFamilies } from '../../../glassConsts';
import Cropper from 'react-easy-crop';
import { onFileChange } from '../../../services/filesHandling';

let mobileCoefficient = 0.8;
if (window.innerWidth < 500) mobileCoefficient = 1;

function VerifiedBadge({ socials }) {
  const { size } = useConfig();
  return (
    <div className="socials_name_top">
      <div className="flex items-center">
        <span
          style={{
            fontSize: (size.width / 40) * mobileCoefficient,
          }}
        >
          {socials.name.length < 1 ? 'Název účtu' : socials.name}
        </span>
        <span className="ml-2 socials-dots">
          {socials.isVerified ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 48 48"
              width={(size.height / 30) * mobileCoefficient}
              height={(size.height / 30) * mobileCoefficient}
            >
              <polygon
                fill="#42a5f5"
                points="29.62,3 33.053,8.308 39.367,8.624 39.686,14.937 44.997,18.367 42.116,23.995 45,29.62 39.692,33.053 39.376,39.367 33.063,39.686 29.633,44.997 24.005,42.116 18.38,45 14.947,39.692 8.633,39.376 8.314,33.063 3.003,29.633 5.884,24.005 3,18.38 8.308,14.947 8.624,8.633 14.937,8.314 18.367,3.003 23.995,5.884"
              />
              <polygon
                fill="#fff"
                points="21.396,31.255 14.899,24.76 17.021,22.639 21.428,27.046 30.996,17.772 33.084,19.926"
              />
            </svg>
          ) : (
            ''
          )}
        </span>
      </div>
    </div>
  );
}

const ProfilePicture = () => {
  const onCropComplete = (handler) => (croppedArea, croppedAreaPixels) => {
    handler(croppedAreaPixels);
  };

  const { socials, setSocialsState, size } = useConfig();
  return (
    <div
      className={`border_poly ${socials.isActiveStory ? 'active_story' : ''}`}
      style={{
        display: 'inline-block',
        position: 'relative',
        width: size.width / 15,
        height: size.width / 15,
        background: '#ffffff',
        boxSizing: 'border-box',
        borderRadius: '50%',
      }}
    >
      <div
        id="socials_profile"
        style={{
          height: size.width / 15,
        }}
      >
        {!socials.profilePicture && (
          <div
            style={{
              color: 'purple',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            <label
              htmlFor="profile-upload"
              className="cursor-pointer text-center"
            >
              +
            </label>
            <input
              type="file"
              accept=".jpg,.jpeg,.png,.pdf,.heic"
              id="profile-upload"
              className="absolute opacity-0 cursor-pointer"
              onChange={onFileChange((url) =>
                setSocialsState({ profilePicture: url })
              )}
              style={{
                height: size.height / 15,
                width: size.height / 15,
                margin: 'auto',
                zIndex: 100000,
                pointerEvents: 'initial',
              }}
            />
          </div>
        )}
        {socials.profilePicture && (
          <div
            className="profile-picture-cropper"
            style={{
              position: 'relative',
              width: '100%',
              height: '100%',
              borderRadius: '50%',
            }}
          >
            <Cropper
              style={{
                width: size.height / 15,
                height: size.height / 15,
                borderRadius: '50%',
              }}
              cropSize={{
                width: size.height / 15,
                height: size.height / 15,
              }}
              cropShape="round"
              zoomWithScroll={false}
              showGrid={false}
              image={socials.profilePicture}
              crop={socials.crop}
              zoom={socials.zoom}
              aspect={1 / 1}
              onCropChange={(c) => setSocialsState({ crop: c })}
              onCropComplete={onCropComplete((px) =>
                setSocialsState({ croppedAreaPixels: px })
              )}
              onZoomChange={(z) => setSocialsState({ zoom: z })}
              objectFit="contain"
            />
          </div>
        )}
      </div>
    </div>
  );
};

const ThreeDots = ({ general }) => {
  const { size } = useConfig();
  return (
    <svg
      className="socials-dots"
      fill={general.color}
      width={size.height / 40}
      viewBox="0 0 122.88 29.956"
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M122.88,14.978c0,8.271-6.708,14.979-14.979,14.979s-14.976-6.708-14.976-14.979 C92.926,6.708,99.631,0,107.901,0S122.88,6.708,122.88,14.978L122.88,14.978z M29.954,14.978c0,8.271-6.708,14.979-14.979,14.979 S0,23.248,0,14.978C0,6.708,6.705,0,14.976,0S29.954,6.708,29.954,14.978L29.954,14.978z M76.417,14.978 c0,8.271-6.708,14.979-14.979,14.979c-8.27,0-14.978-6.708-14.978-14.979C46.46,6.708,53.168,0,61.438,0 C69.709,0,76.417,6.708,76.417,14.978L76.417,14.978z"
        />
      </g>
    </svg>
  );
};

const SocialsHeader = ({ width }) => {
  const { general, socials, size } = useConfig();

  return (
    <div
      style={{
        width: width,
        paddingBottom: size.height / 50,
        color: general.color,
        fontFamily: fontFamilies[general.font],
      }}
      className="flex justify-between items-center socials-header"
    >
      <div className="flex items-center">
        <ProfilePicture />
        <VerifiedBadge socials={socials} />
      </div>

      <ThreeDots general={general} />
    </div>
  );
};

export default SocialsHeader;
